import React from "react";

import Form from "../Components/SmartForm/Form";
import Input from "../Components/SmartForm/Input";
import Label from "../Components/SmartForm/Label";

const RegistrationForm = (props) => {

    return (
        <Form
            id="registration-form"
            action=""
            method="post"
            {...props}
        >
            <div className="form-row">
                <div className="form-group col-md-6">
                    <Label
                        input="firstName"
                        required
                    >
                        First Name
                    </Label>
                    <Input
                        type="text"
                        name="firstName"
                        className="form-control"
                        required
                    />
                </div>
                <div className="form-group col-md-6">
                    <Label
                        input="lastName"
                        required
                    >
                        Last Name
                    </Label>
                    <Input
                        type="text"
                        name="lastName"
                        className="form-control"
                        required
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-12 mt-0 mb-3">
                    <Label
                        input="email"
                        required
                    >
                        Email Address
                    </Label>
                    <Input
                        type="email"
                        name="email"
                        label="Email Address"
                        className="form-control"
                        required
                    />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <Label
                        input="password"
                        required
                    >
                        Password
                    </Label>
                    <Input
                        type="password"
                        name="password"
                        className="form-control"
                        minLength={6}
                        required
                    />
                </div>
                <div className="form-group col-md-6">
                    <Label
                        input="password-confirm"
                        required
                    >
                        Confirm Password
                    </Label>
                    <Input
                        type="password"
                        name="password-confirm"
                        label="Confirm Password"
                        className="form-control"
                        validation={(value, form) => {
                            if (value !== form.elements["password"].value) {
                                return "Passwords must match.";
                            }
                        }}
                        required
                    />
                </div>
            </div>
            <button className="btn btn-lx" type="submit">
                Create Account
            </button>
        </Form>
    );
};

export default RegistrationForm;
